import {
  type CreateWebsiteBlogCategoryRequest,
  type UpdateWebsiteBlogCategoryRequest,
  type WebsiteBlogCategoryListItem,
  WebsiteBlogCategoryListItemSchema,
  type WebsiteBlogCategoryListResponse,
  WebsiteBlogCategoryListResponseSchema,
} from '@utazzo/shared';

import { apiClient } from '@/lib/api-client';

/** Query params for the blog category master grid. */
export interface BlogCategoryListQuery {
  page: number;
  pageSize: number;
  search?: string;
  isActive?: boolean;
}

const BASE = '/admin/website/blog-categories';

export const listBlogCategories = async (
  query: BlogCategoryListQuery,
): Promise<WebsiteBlogCategoryListResponse> => {
  const { data } = await apiClient.get<unknown>(BASE, { params: query });
  return WebsiteBlogCategoryListResponseSchema.parse(data);
};

export const createBlogCategory = async (
  payload: CreateWebsiteBlogCategoryRequest,
): Promise<WebsiteBlogCategoryListItem> => {
  const { data } = await apiClient.post<unknown>(BASE, payload);
  return WebsiteBlogCategoryListItemSchema.parse(data);
};

export const updateBlogCategory = async (
  id: string,
  payload: UpdateWebsiteBlogCategoryRequest,
): Promise<WebsiteBlogCategoryListItem> => {
  const { data } = await apiClient.patch<unknown>(`${BASE}/${id}`, payload);
  return WebsiteBlogCategoryListItemSchema.parse(data);
};

export const deleteBlogCategory = async (id: string): Promise<void> => {
  await apiClient.delete(`${BASE}/${id}`);
};

export const bulkDeleteBlogCategories = async (
  ids: string[],
): Promise<{ updated: number; failed: { id: string; error: string }[] }> => {
  const { data } = await apiClient.post<{
    updated: number;
    failed: { id: string; error: string }[];
  }>(`${BASE}/bulk-delete`, { ids });
  return data;
};

export const bulkSetBlogCategoriesStatus = async (
  ids: string[],
  isActive: boolean,
): Promise<{ updated: number; failed: { id: string; error: string }[] }> => {
  const { data } = await apiClient.post<{
    updated: number;
    failed: { id: string; error: string }[];
  }>(`${BASE}/bulk-set-status`, { ids, isActive });
  return data;
};
